/**
 * Copyright (C) 2021 - 2025 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';

export const TenantLoginGuard = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	const router = inject(Router);

	if (!authService.isLoggedIn) {
		const redirectURL = state.url;
		authService.goToLogin(redirectURL);

		return false;
	}

	return authService.fetchCurrentAdministratorConfig().pipe(
		switchMap((administratorConfig) => {
			if (!administratorConfig?.tenants?.length) {
				if (!administratorConfig.tenants?.length) {
					throw new Error('User has no assigned tenants');
				}

				return of(false);
			}

			// automatically log in single tenant user
			if (!administratorConfig.hasMultipleTenants) {
				return authService.loginToTenant(administratorConfig.tenants[0]).pipe(
					tap(() => {
						router.navigate([authService.redirectUrlAfterLogin]);
					}),
					map(() => false),
				);
			}

			return of(true);
		}),
	);
};
